

import { User} from '@/shared/models';
const AGENCIES_QUERY_URI = '/api/sadmin/users-byname';


export const UsersApi = {
    async findUsers(query) {
        const response = await axios.get(`${AGENCIES_QUERY_URI}?name=`+query);
        return response.data;
    },
    async me() {
        const response = await axios.get('/api/user/me');
        return new User(response.data);
    },
    async createUser(user) {
        const response = await axios.post('/p/api/v1/create-user',user);
        return  response.data;
    },
    async updateUser(user) {
        const response = await axios.post('/api/user',user);
        return  response.data;
    },
    async resetPasswordRequest(email) {
        const response = await axios.post('/p/api/v1/reset-password-request?email='+email);
        return  response.data;
    },
    async resetPassword(obj) {
        const response = await axios.post('/p/api/v1/reset-password?'+new URLSearchParams(obj).toString());
        return  response.data;
    },
    async uploadFile(formData,type) {
        const response = await  axios.post('/api/user/my-file?type='+type, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return  response.data;
    }

};
